export default "<ngx-guided-tour></ngx-guided-tour>";